import {
  AboutNannisCakes,
  MadeByLove,
  OurStory,
} from "~/modules/about-us/components";
import { SubscribeToOurNewsletter } from "~/modules/home/components";

export function AboutUsPage() {
  return (
    <>
      <div className="flex flex-col gap-24 py-14">
        <OurStory />
        <MadeByLove />
        <AboutNannisCakes />
      </div>
      <SubscribeToOurNewsletter />
    </>
  );
}
